import { Fade, Menu, MenuProps } from '@mui/material';

import { BalanceCard } from 'modules/billing/components/BalanceCard';

import { useBalanceMenuStyles } from './useBalanceMenuStyles';

export type BalanceMenuProps = Pick<MenuProps, 'anchorEl' | 'open'> & {
  onClose: () => void;
};

export const BalanceMenu = ({ anchorEl, onClose, open }: BalanceMenuProps) => {
  const { classes } = useBalanceMenuStyles();

  return (
    <Menu
      TransitionComponent={Fade}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 40,
        horizontal: 'left',
      }}
      classes={{
        list: classes.list,
      }}
      disableScrollLock
      keepMounted
      onClose={onClose}
      open={open}
      slotProps={{
        paper: {
          className: classes.paper,
        },
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <BalanceCard className={classes.root} onButtonClick={onClose} />
    </Menu>
  );
};
